/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration401,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration404,
  PostApiV1IndividualpaymentParcelsParcelidResetIntegration500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidResetIntegration.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidResetIntegration } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentParcelsParcelidResetIntegration.ts";

export const postApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationKey =
  () =>
    [
      { url: "/api/v1/individualpayment/parcels/:parcelId/reset-integration" },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration401
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration404
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams["parcelId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId }) => {
      return postApiV1IndividualpaymentParcelsParcelidResetIntegration(
        parcelId,
        config,
      );
    },
  });
}

/**
 * @description Somente parcelas pendentes ou aguardando integração são alteradas. Migrado do legado IndividualPayment/ResetIntegrationParcel. **(Requer Authorization para autenticação)**
 * @summary Limpa a data de integração de uma parcela aberta (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/reset-integration}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidResetIntegration<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidResetIntegration401
        | PostApiV1IndividualpaymentParcelsParcelidResetIntegration404
        | PostApiV1IndividualpaymentParcelsParcelidResetIntegration500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams["parcelId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidResetIntegration401
        | PostApiV1IndividualpaymentParcelsParcelidResetIntegration404
        | PostApiV1IndividualpaymentParcelsParcelidResetIntegration500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams["parcelId"];
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration401
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration404
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams["parcelId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidResetIntegrationMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration401
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration404
      | PostApiV1IndividualpaymentParcelsParcelidResetIntegration500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidResetIntegrationPathParams["parcelId"];
    },
    TContext
  >;
}
